const METRICS = ['size', 'duration', 'position', 'number', 'count'];
export function formatTelemetryMetrics(telemetryData, metricLookup = {}) {
    return Object.keys(telemetryData)
        .filter((key) => {
        return metricLookup[key] || METRICS.includes(key);
    })
        .map((key) => {
        if (metricLookup[key]) {
            return {
                key: getCustomMetricKey(metricLookup, key),
                value: telemetryData[key],
            };
        }
        return {
            key,
            value: telemetryData[key],
        };
    })
        .reduce((acc, { key, value }) => {
        acc[key] = value;
        return acc;
    }, {});
}
function getCustomMetricKey(lookup, key) {
    return `metric${lookup[key]}`;
}
//# sourceMappingURL=format-telemetry-metrics.js.map